import React, { useEffect, useRef, useState, useContext } from 'react'
import { GlobalContext } from "../Globalstate";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from 'react-router-dom';
import Nav from '../Components/Nav';
import Sidebar from '../Components/Sidebar';
import Swal from 'sweetalert2'
import { f, database, storage, auth } from "../config";
import db from "../config";
import firebase from 'firebase';
import emailjs from "emailjs-com";



function Deposit() {
  const history = useNavigate();
  const [{ userdetails, loggedin, tradingpair }, dispatch] = useContext(GlobalContext);
  // onchageinvestments
  const [selectedplan, setselectedplan] = useState("")
  const [Selectedinvestment, setSelectedinvestment] = useState("")
  const [Amount, setAmount] = useState(0)
  const [loading, setloading] = useState(true)
  const [Coins, setCoins] = useState([]);
  const [image, setimage] = useState(null);
  const [url, seturl] = useState("");
  const [progress, setprogress] = useState(0);
  const [imagepresnt, setimagepresent] = useState(false);
  const [prevfile, setprevFile] = useState("")
  const [CoinInfo, setCoinInfo] = useState("")
  const [step, setstep] = useState(0)

      const [navOpen, setNavOpen] = useState(false); // Toggle state for Nav

    useEffect(() => {
  if (window.innerWidth >= 1024) { // example breakpoint for large screens
    setNavOpen(true);
  }
}, []);
 // Toggle state for Nav
  
    // Toggle function for Nav
    const handleToggleSidebar = () => {
      setNavOpen(!navOpen);
    };
  


  const images = [
    {
      src: 'https://public.newsdirect.com/414339981/17MYMJsd.jpg',
      alt: 'Image 1',
      href: 'https://bingx.com/en-us/',
    },
    {
      src: 'https://altcoinsbox.com/wp-content/uploads/2023/04/full-bitget-logo.png',
      alt: 'Image 2',
      href: 'https://www.bitget.com/',
    },
    {
      src: 'https://getvectorlogo.com/wp-content/uploads/2019/11/kraken-vector-logo.png',
      alt: 'Image 2',
      href: 'https://www.kraken.com/',
    },
    {
      src: 'https://images.ctfassets.net/q5ulk4bp65r7/3TBS4oVkD1ghowTqVQJlqj/2dfd4ea3b623a7c0d8deb2ff445dee9e/Consumer_Wordmark.svg',
      alt: 'Image 2',
      href: 'https://www.coinbase.com/',
    },
    {
      src: 'https://assets.staticimg.com/g-biz/externals/2022-06-01/9bfcd9feaf2b8bed.svg',
      alt: 'Image 2',
      href: 'https://www.kucoin.com/',
    },
    {
      src: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Binance_logo.svg/948px-Binance_logo.svg.png',
      alt: 'Image 2',
      href: 'https://www.binance.com/en',
    },
    // Repeat the pattern for the remaining images
  ];


  const investments = [
    {
      id: "1",
      name: "Beginner Plan",
      minimum: "100",
      Maximum: "1000",
      profits: "5",
      duration: "1"
    },
    {
      id: "2",
      name: "AMATEUR PLAN ",
      minimum: "1000",
      Maximum: "5000",
      profits: "3.33",
      duration: "3"
    },
    {
      id: "3",
      name: "ADVANCE PLAN",
      minimum: "5000",
      Maximum: "10000",
      profits: "3",
      duration: "5"
    },
    {
      id: "4",
      name: "PRO PLAN",
      minimum: "10000",
      Maximum: "100000",
      profits: "2.5",
      duration: "10"
    },
    {
      id: "5",
      name: "EXPERT PLAN",
      minimum: "100000",
      Maximum: "1000000",
      profits: "2.6",
      duration: "15"
    }
  ]
  const SetInvestment = (value) => {
    setselectedplan(value)
    let selectedinvestment = investments.find(o => o.id === value);
    console.log(selectedinvestment)
    setSelectedinvestment(selectedinvestment)
  }
  // onchageCryptoCurrency 
  const CoinsList = [
    {
      id: "1",
      name: "BITCOIN",
      address: "bc1q2vsdgfjccr87jecqfp29pehmuq67gcpqmvzslk"
    },
    {
      id: "3",
      name: "ETHEREUM",
      address: "0xA15c8bC1bB9E70ab1583F9d0a78762b1402C580E"
    },
    {
      id: "2",
      name: "USDT ERC20",
      address: "0xA15c8bC1bB9E70ab1583F9d0a78762b1402C580E"
    },
    {
      id: "4",
      name: "USDT bep20",
      address: "0xA15c8bC1bB9E70ab1583F9d0a78762b1402C580E"
    },
  ]
  const SetCoinInfo = (value) => {
    let selectedcoin = CoinsList.find(o => o.id === value);
    Swal.fire({
      position: 'top-end',
      icon: 'success',
      title: `You Selected ${selectedcoin.name} as Payment Method`,
      showConfirmButton: false,
      timer: 1500
    })
    setCoinInfo(selectedcoin)
  }
  const Confirmation = () => {
    if (Amount != 0 && CoinInfo != "" && Selectedinvestment != "") {
      if (parseInt(Amount) >= Selectedinvestment.minimum && parseInt(Amount) <= Selectedinvestment.Maximum) {
        setstep(1)
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'You selected the wrong investment for selected amount',
          footer: '<a href="">Why do I have this issue?</a>'
        })
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'please fill in the required fields!',
        footer: '<a href="">Why do I have this issue?</a>'
      })
    }
  }
  // const Confirmation = () => {
  //   if (Amount != 0 && CoinInfo != "" && Selectedinvestment != "") {
  //     setstep(1)
  //   } else {
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Oops...',
  //       text: 'please fill in the required fields!',
  //       footer: '<a href="">Why do I have this issue?</a>'
  //     })
  //   }
  // }
  const handleChange = (e) => {
    if (e.target.files[0]) {
      setimage(e.target.files[0]);
      setimagepresent(true);
      setprevFile(URL.createObjectURL(e.target.files[0]))
    }
  };
  const handleUpload = () => {

    if (Amount != 0 && CoinInfo != "") {
      if (!imagepresnt) {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'No Image Was Selected!',
        })
        return
      }
      //check wether amt is empty or file is not selected
      const uploadTask = storage.ref(`images/${image.name}`).put(image);
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          const progress = Math.round(
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100
          );
          setprogress(progress);
        },
        (error) => {
          console.log(error);
        },
        () => {
          storage
            .ref("images")
            .child(image.name)
            .getDownloadURL()
            .then((url) => {
              seturl(url);
              updatehistory(url);
              setprogress(0);
              setimagepresent(false)
              sendAdminMaiil()
              Swal.fire(
                'Succesful Transaction!',
                'Your account will be credited once the payment is recieved.',
                'success'
              )
              // alert("we will we credit your balance shortly");
              setimage(null);
              // history("/dashboard")
            });
        }
      );
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'please fill in the required fields!',
        footer: '<a href="">Why do I have this issue?</a>'
      })
    }

  };



  const sendAdminMaiil = async () => {
    var templateParams = {
      message:
        `${userdetails.fullname} made a deposit to his account to activate an investment`,
    };
    await emailjs
      .send(
        "service_5jy1gr4", "template_zntnjos",
        templateParams,
        "HNlgG_D2lYE6E-7Q3"
      )
      .then(
        function (response) {
          // setloading(false)
        },
        function (err) {
          // setloading(false)
          alert("FAILED...", err);
        }
      );
  }

  const CreatUserObj = async (obj) => {
    var userid = f.auth().currentUser;
    var userids = userid.uid;
    let uobj = {
      fullname: userdetails.fullname,
      email: userdetails.email,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      userid: userids,
      info: obj
    };

    const userdetail1 = await db
      .collection("deposits")
      .add(uobj)
      .then(function () {
        console.log("Document successfully written!");
        Swal.fire(
          'Succesful Transaction!',
          'Your Investment will been activated.',
          'success'
        )
        window.location.replace("/dashboard");
      })
      .catch(function (error) {
        console.error("Error writing document: ", error);
      });
  };
  const updatehistory = async (urls) => {
    var userid = f.auth().currentUser;
    var userids = userid.uid;
    const increment = firebase.firestore.FieldValue.increment(parseInt(Amount));
    CreatUserObj({
      image: urls,
      date: Date.now(),
      amt: Amount,
      mode: "Deposit",
      coin: CoinInfo.name,
      investmentplan: selectedplan
    })
    var washingtonRef = db.collection("users").doc(userids);
    await washingtonRef.update({
      // Totaldeposit: increment,
      Deposithistory: firebase.firestore.FieldValue.arrayUnion({
        image: urls,
        date: Date.now(),
        amt: Amount,
        mode: "Deposit",
        coin: CoinInfo.name,
        investmentplan: selectedplan
      }),
    });
  };




  useEffect(() => {
    if (loggedin) {
      console.log(userdetails);
      console.log(userdetails.email);
      setloading(false)
    } else {
      f.auth().onAuthStateChanged(function (user) {
        if (user) {
          var userid = f.auth().currentUser;
          var userids = userid.uid;
          fetchuserdata(userids);
          setloggedin(true);
        } else {
          setloggedin(false);
          setloading(false)
          history("/");
        }
      });
    }

    let myDate = new Date();
    console.log(myDate.getTime())
    console.log(addHoursToDate(myDate, 1).getTime())
    console.log(myDate)
    console.log(addHoursToDate(myDate, 1))

  }, []);

  function addHoursToDate(date, hours) {
    return new Date(new Date(date).setHours(date.getHours() + hours));
  }

  const fetchuserdata = async (userid) => {
    var docRef = db.collection("users").doc(userid);
    const fetching = await docRef
      .onSnapshot((function (doc) {
        if (doc.exists) {
          setdetails(doc.data());
          console.log(doc.data())
          setloading(false)
        } else {
          console.log("No such document!");
        }
      })
      )

  };

  const setdetails = (data) => {
    dispatch({ type: "setuserdetails", snippet: data });
  };

  const setloggedin = (data) => {
    dispatch({ type: "setloggedin", snippet: data });
  };


  return (
    <div>
           <Helmet>
             <script src="dashboard/js"></script>
             <script src="dashboard/js/bootstrap.bundle.min.js"></script>
             <script src="dashboard/js/modernizr.js"></script>
             <script src="dashboard/js/moment.js"></script>
             <script src="dashboard/js/megamenu.js"></script>
             <script src="dashboard/js/custom.js"></script>
             <script src="dashboard/js/slimscroll.min.js"></script>
             <script src="dashboard/js/custom-scrollbar.js"></script>
             <script src="dashboard/js/search-filter.js"></script>
             <script src="dashboard/js/custom-search-filter.js"></script>
             <script src="dashboard/js/apexcharts.min.js"></script>
             <script src="dashboard/js/salesGraph.js"></script>
             <script src="dashboard/js/ordersGraph.js"></script>
             <script src="dashboard/js/earningsGraph.js"></script>
             <script src="dashboard/js/visitorsGraph.js"></script>
             <script src="dashboard/js/customersGraph.js"></script>
             <script src="dashboard/js/sparkline.js"></script>
             <script src="dashboard/js/circliful.min.js"></script>
             <script src="dashboard/js/circliful.custom.js"></script>
             <script src="dashboard/js/main.js"></script>
             
             <style>{`
               /* Nav toggle styles */
               .nav-wrapper {
                 transition: transform 0.3s ease-in-out;
               }
               
               .nav-wrapper.nav-hidden .sidebar-wrapper {
                 transform: translateX(-100%) !important;
               }
               
               .nav-wrapper.nav-visible .sidebar-wrapper {
                 transform: translateX(0) !important;
               }
               
               /* Adjust main container margin */
               .main-container {
                 transition: margin-left 0.3s ease-in-out;
               }
               
               .page-wrapper.nav-closed .main-container {
                 margin-left: 0 !important;
               }
               
               /* Toggle button cursor */
               .toggle-sidebar {
                 cursor: pointer !important;
               }
               
               /* Mobile responsive */
               @media (max-width: 991px) {
                 .nav-wrapper.nav-visible::before {
                   content: '';
                   position: fixed;
                   top: 0;
                   left: 0;
                   right: 0;
                   bottom: 0;
                   background: rgba(0,0,0,0.5);
                   z-index: 998;
                 }
               }
             `}</style>
           </Helmet>
      {/* Required meta tags */}
      <meta charSet="utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
      {/*--------------- www.hyipcustomize.com ---------*/}
      <meta name="designer" href="https://hyipcustomize.com/" />
      {/* Title */}
      <title>Acorn-mart | Dashboard</title>
      {/* *************
        ************ Common Css Files *************
    ************ */}
      {/* Bootstrap css */}
      <link rel="stylesheet" href="dashboard/css/bootstrap.min.css" />
      {/* Icomoon Font Icons css */}
      <link rel="stylesheet" href="dashboard/fonts/style.css" />
      {/* Main css */}
      <link rel="stylesheet" href="dashboard/css/main.css" />
      {/* *************
        ************ Vendor Css Files *************
    ************ */}
      {/* Mega Menu */}
      <link rel="stylesheet" href="dashboard/vendor/megamenu/css/megamenu.css" />
      {/* Search Filter JS */}
      <link rel="stylesheet" href="dashboard/vendor/search-filter/search-filter.css" />
      <link rel="stylesheet" href="dashboard/vendor/search-filter/custom-search-filter.css" />
      {/* Loading wrapper start */}
      {/* Loading wrapper end */}
      {/* Page wrapper start */}
      <div className={`page-wrapper ${!navOpen ? 'nav-closed' : ''}`}>
        {/* Nav wrapper with toggle control */}
        <div
          className={`nav-wrapper ${navOpen ? "nav-visible" : "nav-hidden"}`}
        >
          {navOpen ? <Nav /> : <></>}
        </div>
        {/* Sidebar wrapper end */}
        {/* *************
            ************ Main container start *************
        ************* */}
        <div className="main-container">
          {/* Page header starts */}
          <div className="page-header">
            {/* Row start */}
            <div className="row gutters">
              <div className="col-xl-8 col-lg-8 col-md-8 col-sm-6 col-9">
                {/* Search container start */}
                <div className="search-container">
                  {/* Toggle sidebar start */}
                   <div 
                    className="toggle-sidebar" 
                    id="toggle-sidebar"
                    onClick={handleToggleSidebar}
                  >
                    <i className="icon-menu" />
                  </div>
                  {/* Toggle sidebar end */}
                </div>
                {/* Search container end */}
              </div>
              <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-3">
                {/* Header actions start */}
                <ul className="header-actions">
                  <li className="dropdown">
                    <a href="#" id="userSettings" className="user-settings" data-toggle="dropdown" aria-haspopup="true">
                      Hi {userdetails.fullname} &nbsp;
                      <span className="avatar">
                        <img src="https://img.icons8.com/?size=1x&id=kDoeg22e5jUY&format=png" alt="User Avatar" />
                        <span className="status busy" />
                      </span>
                    </a>
                    <div className="dropdown-menu dropdown-menu-end md" aria-labelledby="userSettings">
                      <div className="header-profile-actions">
                        <a href="?a=edit_account"><i className="icon-user1" />Profile</a>
                        <a href="?a=security"><i className="icon-warning" />Security</a>
                        <a href="?a=logout"><i className="icon-log-out1" />Logout</a>
                      </div>
                    </div>
                  </li>
                </ul>
                {/* Header actions end */}
              </div>
            </div>
            {/* Row end */}
          </div>
          {/* Page header ends */}
          {/* Content wrapper scroll start */}
          <div className="content-wrapper-scroll">
            {/* Content wrapper start */}
            <div className="content-wrapper">
              <br />
              {/* Row start */}
              <div className="row gutters">
                <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                  {/* Card start */}
                  <div className="card">
                    <div className="card-header">
                      <div className="card-title">Make A Deposit</div>
                    </div>
                    <div className="card-body">
                      {/* Row start */}
                      <div className="row gutters">
                        <div className="col-md-12">
                          {/* Card start */}


                          {
                            step == 0 && (
                              <div className="card">
                                <div className="card-header">
                                  <div className="card-title">Fill The Form</div>
                                </div>
                                <div className="card-body">
                                  {/* Row start */}
                                  <div className="row gutters">
                                    <form method="post" name="spendform"><input type="hidden" name="form_id" defaultValue={16862959794119} /><input type="hidden" name="form_token" defaultValue="08bae86c7de245e360aca85c0268335b" />
                                      <input type="hidden" name="a" defaultValue="deposit" />
                                      <div className="col-md-12">
                                        {/* Field wrapper start */}
                                        <div className="field-wrapper">
                                          <input className="form-control" type="text" defaultValue={userdetails.balance} disabled />
                                          <div className="field-placeholder">Your Account Balance</div>
                                        </div>
                                        {/* Field wrapper end */}
                                      </div>
                                      <div className="col-md-12">
                                        {/* Field wrapper start */}
                                        <div className="field-wrapper">
                                          <select className="form-select" id="formSelect" name="h_id" onChange={(e) => { SetInvestment(e.target.value) }}>
                                            <option >Select Plan Plan</option>
                                            <option value="1">Beginner Plan</option>
                                            <option value="2">AMATEUR PLAN</option>
                                            <option value="3">ADVANCE PLAN</option>
                                            <option value="4">PRO PLAN</option>
                                            <option value="5">EXPERT PLAN</option>

                                          </select>
                                          <div className="field-placeholder">Select Package</div>
                                        </div>
                                        {/* Field wrapper end */}
                                      </div>
                                      <div className="col-md-12">
                                        {/* Field wrapper start */}
                                        <div className="field-wrapper">
                                          <select className="form-select" id="formSelect" name="type" onChange={(e) => { SetCoinInfo(e.target.value) }}>
                                            <option >Select Payment Method</option>
                                            <option value="1" checked>Bitcoin</option>
                                            <option value="2">Tether USDT ERC20</option>
                                            <option value="4">Tether USDT Bep20</option>
                                          </select>
                                          <div className="field-placeholder">Select Payment Method</div>
                                        </div>
                                        {/* Field wrapper end */}
                                      </div>
                                      <div className="col-md-12">
                                        {/* Field wrapper start */}
                                        <div className="field-wrapper">
                                          <input className="form-control" type="text" name="amount" onChange={(e) => { setAmount(e.target.value) }} />
                                          <div className="field-placeholder">Enter Amount</div>
                                        </div>
                                        {/* Field wrapper end */}
                                      </div>
                                      <div className="col-md-12">
                                        <button className="btn btn-primary" type="button" onClick={Confirmation}>Deposit</button>
                                      </div>
                                    </form>
                                  </div>
                                  {/* Row end */}
                                </div>
                              </div>
                            )}
                          {
                            step == 1 && (
                              <div className="card">
                                <div className="card-header">
                                  <div className="card-title">Deposit Confirmation</div>
                                </div>
                                <div className="card-body">
                                  <br /><br />
                                  Please send your {CoinInfo.name} payments to this {CoinInfo.name} Address: <b><a href="Bitcoin: 
                CoinInfo.address
                "><font color="red">
                                      {CoinInfo.address}
                                    </font></a></b><br /><br />
                                  <div className="table-responsive">
                                    <table className="table products-table">
                                      <tbody><tr>
                                        <th>Plan:</th>
                                        <td>{Selectedinvestment.name}</td>
                                      </tr>
                                        <tr>
                                          <th>Profit:</th>
                                          <td>{(Selectedinvestment.profits / 100) * Amount} Daily for {Selectedinvestment.duration} day </td>
                                        </tr>
                                        <tr>
                                          <th>Principal Return:</th>
                                          <td>Yes</td>
                                        </tr>
                                        <tr>
                                          <th>Principal Withdraw:</th>
                                          <td>
                                            Available with
                                            0.00% fee</td>
                                        </tr>
                                        <tr>
                                          <th>Credit Amount:</th>
                                          <td>${Amount}</td>
                                        </tr>
                                        <tr>
                                          <th>Deposit Fee:</th>
                                          <td>0.00% + $0.00 (min. $0.00 max. $0.00)</td>
                                        </tr>
                                        <tr>
                                          <th>Debit Amount:</th>
                                          <td>${Amount}</td>
                                        </tr>
                                        <tr>
                                          <th> Debit Amount:</th>
                                          <td>{Amount}</td>
                                        </tr>
                                      </tbody></table>
                                    <br /><br />
                                    <form name="spend"><input type="hidden" name="form_id" defaultValue={16862961841002} /><input type="hidden" name="form_token" defaultValue="066e34da366d885f78e7b290c16190f8" />
                                      <input type="hidden" name="a" defaultValue="deposit" />
                                      <input type="hidden" name="action" defaultValue="confirm" />
                                      <input type="hidden" name="type" defaultValue="process_1006" />
                                      <input type="hidden" name="h_id" defaultValue={1} />
                                      <input type="hidden" name="compound" defaultValue={0} />
                                      <input type="hidden" name="amount" />
                                      <table cellSpacing={0} cellPadding={2} border={0}>
                                        <tbody><tr>
                                          <td colSpan={2}><b>Required Information:</b></td>
                                        </tr>
                                          <tr>
                                            <td>Transaction ID</td>
                                            <td><input type="text" className="inpts" /></td>
                                          </tr>
                                        </tbody></table>
                                      <br />

                                      {/* <input type="button" defaultValue="Save" onClick={handleUpload} className="se" /> */}

                                      <input type="hidden" name="_token" defaultValue="zn8v4I2d4bZyK4wpUA2IxCApAntbf4ODlmrnGzIz" />													<div className="form-group">
                                        <h5 className="text-dark">Upload Payment proof after payment.</h5>
                                        <input type="file" name="proof" onChange={handleChange} className="form-control col-lg-4 bg-light text-dark" required />
                                      </div>
                                      <div className="form-group">


                                        {
                                          imagepresnt && (
                                            <>
                                              <progress id="file" value={progress} max="100"> {progress} </progress>
                                              <input type="button" className="btn btn-dark" defaultValue="Submit Payment" onClick={handleUpload} />
                                            </>

                                          )
                                        }
                                      </div>



                                      &nbsp;
                                      <input type="button" className="sbmt" defaultValue="Cancel" onClick={() => { setstep(0) }} />
                                    </form>
                                  </div></div></div>
                            )
                          }
                          {/* Card end */}
                        </div>
                      </div>
                      {/* Row end */}
                    </div>
                    {/* Content wrapper end */}
                    {/* App footer start */}
                    <div className="app-footer">© Acorn-mart</div>


                    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>
                      {images.map((image, index) => (
                        <a
                          key={index}
                          href={image.href}
                          style={{
                            flex: '1 0 45%', // Adjust the width as needed
                            margin: '5px',
                            textDecoration: 'none',
                            color: 'inherit',
                          }}
                        >
                          <img
                            src={image.src}
                            alt={image.alt}
                            style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
                          />
                        </a>
                      ))}
                    </div>

                    {/* App footer end */}
                  </div>
                  {/* Content wrapper scroll end */}
                </div>
                {/* *************
            ************ Main container end *************
        ************* */}
              </div>
              {/* Page wrapper end */}
              {/* *************
        ************ Required JavaScript Files *************
    ************* */}
              {/* Required jQuery first, then Bootstrap Bundle JS */}
              {/* *************
        ************ Vendor Js Files *************
    ************* */}
              {/* Megamenu JS */}
              {/* Slimscroll JS */}
              {/* Search Filter JS */}
              {/* Apex Charts */}
              {/* Circleful Charts */}
              {/* Main Js Required */}
              {/*Start of Tawk.to Script*/}
              {/*End of Tawk.to Script*/}
            </div></div></div></div></div>
  )
}

export default Deposit